<template>
  <forgerock-template id="otp" :title="$t('dss.page.otp.title')">

    <bootstrap-alerts :alerts="alerts"/>

    <stihl-section :title="$t('dss.page.otp.subtitle')">
      <stihl-overlay :active="state === 'loading'" :spinner="true">

        <form @submit.prevent="save">
          <label>{{ $t('dss.page.otp.txtVerifyMail', {email: email ?? 'N/A'}) }}</label>

          <otp-input id="otp"
                     :label="$t('dss.page.otp.txtVerifyMail', {email: email})"
                     group-class="form-group"
                     :required="true"
                     autofocus
                     v-model="form.otp"
                     :validation-errors="v$.form.otp.$errors"
                     @keypress.enter="save"/>

          <div class="buttons">
            <button id="save" type="button" class="btn btn-primary" @click="save" :disabled="state === 'loading'">
              {{ $t('dss.button.continue') }}
            </button>
            <button id="back" type="button" class="btn btn-default" @click="back">
              {{ $t('dss.button.back') }}
            </button>
          </div>
        </form>

        <div class="pt-5">
          <h5>{{ $t('dss.page.otp.spamTitle') }}</h5>
          <label class="m-0">{{ $t('dss.page.otp.spamDetail') }}</label>
        </div>

        <div class="buttons">
          <button id="resend" type="button" class="btn btn-secondary" @click="resend" :disabled="state === 'loading'">
            {{ $t('dss.page.otp.btnResend') }}
          </button>
          <help-menu/>
        </div>

      </stihl-overlay>
    </stihl-section>

  </forgerock-template>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import StihlSection from "@/components/ui/StihlSection.vue";
import OtpInput from "@/components/ui/OtpInput.vue";
import {Alert} from "@/components/ui/BootstrapAlerts.vue";
import useVuelidate from '@vuelidate/core'
import {validOTP} from "@/components/validators";
import {helpers, required} from '@vuelidate/validators'
import ForgerockTemplate from "@/components/layout/ForgerockTemplate.vue";
import HelpMenu from "@/components/ui/HelpMenu.vue";
import {i18n} from "@/lang";
import Backend, {RestError} from "@/components/backend";
import {mapState} from "pinia";
import {useUserStore} from "@/components/user.store";
import {AxiosError} from "axios";

export default defineComponent({
  name: "OTPPage",
  components: {HelpMenu, ForgerockTemplate, StihlSection, OtpInput},
  data() {
    return {
      form: {
        otp: '',
      },
      state: 'ready',
      alerts: [] as Alert[],
    }
  },
  computed: {
    ...mapState(useUserStore, ['email']),
  },
  methods: {
    alert(message: string, _class?: string) {
      this.alerts.push({message, class: _class})
    },
    back() {
      window.history.back()
    },
    resend() {
      if (this.state === 'loading') {
        console.log("wait. loading");
        return;
      }

      this.alerts = []
      this.state = 'loading';

      Backend.resendOTP({
        email: this.email as string,
        locale: i18n.global.locale,
      }).then((_r) => {
        this.state = 'ready';
        console.log("[otp] resent")
      }).catch(_e => {
        this.state = 'error';
        this.alert(this.$t('dss.page.otp.msg.resendFail'))
      })
    },
    save() {
      if (this.state === 'loading') {
        console.log("wait. loading");
        return;
      }

      this.v$.$touch() // trigger validation
      if (this.v$.$invalid) return console.error("validation failed", this.v$.$errors)

      this.alerts = []
      this.state = 'loading';

      Backend.validateOTP({
        email: this.email as string,
        code: this.form.otp,
      }).then((r) => {
        //console.log("[otp]goto set-password")
        useUserStore().setPasswordToken = r.data.token
        this.$router.push({
          name: 'setPassword',
          query: {
            showTC: String(r.data.showTC),
          }
        })
        this.state = 'ready'; //?
      }).catch((e: AxiosError<RestError>) => {
        this.state = 'error';
        if (e.response?.data?.code === 'INVALID_PARAMETER' && e.response?.data?.invalidField === "token") {
          return this.alert(this.$t('dss.page.otp.msg.invalidOTP'));
        }
        this.alert(this.$t('dss.error.generic'));
      })
    }
  },
  mounted() {
    console.assert(!!this.email, "DSS::OTP email missing")
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      form: {
        // must match the fields in 'this.form'
        otp: {
          validOTP, required: helpers.withMessage(this.$t('dss.validations.validOTP'), required),
        },
      }
    }
  },
})
</script>

<style scoped>
</style>
